import Path from '@leverege/path'
import ObjectUtil from '@leverege/object-util'
import { combineReducers } from 'redux'
import DeviceActions from '~/actions/DeviceActions.js'

const initialState = {
  device : null,
  blueprint : null,
  updaters : {},
  status : 'none'
};

function deviceBlueprint( state = initialState, action ) {
  
  switch ( action.type ) {
    case DeviceActions.LOADING_DEVICE_BLUEPRINT:
      return { device : null, blueprint : null, updaters : {}, status : DeviceActions.LOADING_DEVICE_BLUEPRINT };

    case DeviceActions.GET_DEVICE_BLUEPRINT:
      return { device : action.device, 
               system : action.system,
               blueprint : action.blueprint, 
               updaters : {},
               status : null };

    case DeviceActions.DEVICE_BLUEPRINT_ERROR:
      return { device : null,
               blueprint : null,
               updaters : {},
               status : { status : action.status,
                          message : action.message } };

    case DeviceActions.SET_DEVICE_UPDATER: {
      const copy = ObjectUtil.copy( state )
      copy.updaters[action.path] = action.updater
      return copy 
    }
    case DeviceActions.GET_DEVICE_UPDATERS: {
      const copy = ObjectUtil.copy( state )
      copy.updaters = action.updaters
      return copy 
    }

    default:
      return state
  }
}

module.exports = deviceBlueprint;
